import { getState } from './state';
import { makeBuildUrl } from './controls';

export const generateSpokeSummary = (groups: [string, number, number][]) => {
  const container = document.getElementById('spoke-summary');
  container?.replaceChildren();
  if (groups.length === 0) {
    const msg = document.createElement('p');
    msg.classList.add('summary-message');
    msg.textContent = 'Wheel has no spokes';
    container?.appendChild(msg);
  } else {
    const angleThreshold = getState().viewParameters.angleThreshold.value;
    const hasExtremeAngles = getState().wheel?.hasExtremeAngles(angleThreshold) ?? false;
    if (hasExtremeAngles) {
      const msg = document.createElement('p');
      msg.classList.add('summary-message', 'warning');
      msg.textContent = `Some spokes have rim or bracing angle exeeding ${angleThreshold.toFixed(1)} degrees!`;
      container?.appendChild(msg);
    }
    const table = document.createElement('table');
    table.classList.add('spoke-summary-table');
    let html = '<thead><tr><th>Group</th><th>Length, mm</th><th>Quantity</th></tr></thead>';
    let numRows = 0;
    const numSpokes = groups.reduce((acc, cur) => acc + cur[2], 0);
    for (const [group, length, quantity] of groups) {
      const row = `<tr><td>${group}</td><td>${length.toFixed(1)}</td><td>${quantity}</td></tr>`;
      html += row;
      numRows += 1;
    }
    if (numRows > 1) {
      html += `<tr><td><i>Total<i></td><td></td><td><i>${numSpokes}<i></td></tr>`;
    }
    table.innerHTML = html;
    container?.appendChild(table);
    const urlMsg = document.createElement('p');
    urlMsg.classList.add('summary-build-url', 'print-only');
    urlMsg.textContent = `Build url: ${makeBuildUrl()}`;
    container?.appendChild(urlMsg);
  }
};
